import React from 'react';
import { Col, Row } from 'react-bootstrap';

interface PROPS {
    title: string;
    description: string;
    imageUrl: string;
}

const StepComponent = ({ title, description, imageUrl }: PROPS) => {
    return (
        <Row className="align-items-center my-5" style={{
            maxWidth: '1000px',
            margin: '0 auto',
        }}>
            <Col xs={12} md={6} className="text-white text-center text-md-start" style={{
                marginTop: 25
            }}>
                <h2 className="text-white" style={{
                    textAlign: 'left',
                    fontFamily: 'carto-heavy',
                }}>{title.toUpperCase()}</h2>
                <p className='text-white' style={{
                    textAlign: 'left',
                    whiteSpace: 'pre-line',
                    marginTop: 10
                }}>{description}</p>
            </Col>
            <Col xs={12} md={6} className="text-center">
                <img src={imageUrl} alt={title} className="img-fluid" style={{
                    maxWidth: '320px',
                    margin: '0 auto',
                    width: '100%',

                }} />
            </Col>
        </Row>
    );
};


export default StepComponent;
